import { render, staticRenderFns } from "./changeFeeList.vue?vue&type=template&id=f6ef7450&scoped=true"
import script from "./changeFeeList.vue?vue&type=script&lang=js"
export * from "./changeFeeList.vue?vue&type=script&lang=js"
import style0 from "./changeFeeList.vue?vue&type=style&index=0&id=f6ef7450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ef7450",
  null
  
)

export default component.exports